import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import authHeader from "./authHeader";
import { apiInstance } from "./axiosApi";

export const getAllKyc = createAsyncThunk(
  "admin/kyc",
  async ({ page, limit, filter, searchData }, { rejectWithValue }) => {
    try {
      let url = `/kyc/all?page=${page}&limit=${limit}`;
      if (filter) {
        url += `&statusFilter=${filter}`;
      }
      if (searchData) {
        url += `&search=${searchData}`;
      }
      const response = await apiInstance.get(url, {
        headers: authHeader(),
      });
      return response
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const deleteKyc = createAsyncThunk(
  "admin/kyc",
  async (selectedId, { rejectWithValue }) => {
    try {
      const response = await apiInstance.delete(
        `/kyc/delete/${selectedId}`,
        {
          headers: authHeader(),
        }
      );
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const updateKycStatus = createAsyncThunk(
  "kyc/edit",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await apiInstance.post(`/kyc/edit`, payload, {
        headers: authHeader(),
      });
      return response
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);
const initialState={}
const kycSlice = createSlice({
  name: "kycSlice",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllKyc.fulfilled, (state, action) => {
      state.kycData = action.payload.data;
    });
  },
});
export default kycSlice.reducer;
